import React from 'react';
import format from 'string-template';
import { connect } from 'react-redux';
import { toPlainObject, isEmpty } from 'lodash';

import {
    FormComponent,
    EmailInputFieldComponent,
    LegendFieldComponent
} from '../../../components/form';
import { BRAND_NAME } from '../../../constants';
import { SuccessInfoComponent } from '../../form/SuccessInfoComponent';
import { sendUnsubscribeRequest } from '../../../services/unsubscribe/actions';

const FORM_NAME = 'unsubscribe-form';

class UnsubscribeFormComponent extends React.Component {
    submit = formData => {
        const { sendUnsubscribeRequest } = this.props;
        sendUnsubscribeRequest(formData);
    };

    render() {
        const {
            i18n,
            initialValues,
            isAuthed,
            errorMessage,
            requestSubmit,
            errorSubmit,
            successSubmit
        } = this.props;

        if (!successSubmit) {
            return (
                <FormComponent
                    form={FORM_NAME}
                    initialValues={isAuthed ? initialValues : {}}
                    onSubmit={this.submit}
                    requestSubmit={requestSubmit}
                    errorSubmit={errorSubmit}
                    submitText={i18n.BUTTON_TEXT}
                    hideInputsOnSuccess>
                    <EmailInputFieldComponent
                        label={format(i18n.LABEL, BRAND_NAME)}
                        name="email"
                        isRequired
                        className="one-half"
                    />
                    {errorMessage && (
                        <LegendFieldComponent classNameInputContainer="color-err">
                            {errorMessage}
                        </LegendFieldComponent>
                    )}
                </FormComponent>
            );
        } else {
            return (
                <SuccessInfoComponent>
                    <p>{i18n.SUBMIT_SUCCEEDED}</p>
                </SuccessInfoComponent>
            );
        }
    }
}

function mapStateToProps(state) {
    const user = toPlainObject(state.account.user);

    return {
        i18n: state.i18n.page.UNSUBSCRIBE,
        isAuthed: !isEmpty(state.authentication.token),
        initialValues: {
            email: user.email ? user.email : ''
        },
        errorMessage: state.unsubscribe.error,
        requestSubmit: state.unsubscribe.fetching,
        errorSubmit: !isEmpty(state.unsubscribe.errorMessage),
        successSubmit: state.unsubscribe.successUnsubscribeRequestSubmit
    };
}

const mapDispatchtoProps = {
    sendUnsubscribeRequest
};

export default connect(mapStateToProps, mapDispatchtoProps)(UnsubscribeFormComponent);



// WEBPACK FOOTER //
// ./src/components/pages/unsubscribe/UnsubscribeFormComponent.js